import { motion } from 'framer-motion'
import ScrollReveal from '../shared/ScrollReveal'
import GradientText from '../shared/GradientText'
import './FeatureSections.css'

export default function SpaceSection() {
  const dataSources = [
    { name: 'NASA POWER', type: 'Irradiance', years: '40+', status: 'active' },
    { name: 'Copernicus', type: 'NDVI', years: 'Real-time', status: 'active' },
    { name: 'Open-Meteo', type: 'Weather', years: 'Hourly', status: 'active' }
  ]

  return (
    <section className="feature-section feature-section-space" id="space">
      <div className="container">
        <div className="feature-grid feature-grid-reverse">
          <ScrollReveal animation="fadeLeft" className="feature-visual">
            <div className="satellite-visual">
              {/* Earth visualization */}
              <div className="earth-container">
                <motion.div
                  className="earth"
                  animate={{ rotate: 360 }}
                  transition={{ duration: 60, repeat: Infinity, ease: 'linear' }}
                >
                  <div className="earth-surface" />
                </motion.div>

                {/* Orbit ring */}
                <div className="orbit-ring">
                  <motion.div
                    className="satellite-icon"
                    animate={{ rotate: -360 }}
                    transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="10" width="20" height="4" fill="#A855F7" rx="1" />
                      <rect x="9" y="4" width="6" height="16" fill="#6366F1" rx="1" />
                      <circle cx="12" cy="12" r="2" fill="#00D4FF" />
                    </svg>
                  </motion.div>
                </div>

                {/* Data beams */}
                <svg className="data-beams" viewBox="0 0 200 200">
                  <motion.line
                    x1="100" y1="100" x2="60" y2="160"
                    stroke="#A855F7"
                    strokeWidth="1"
                    strokeDasharray="4 4"
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    transition={{ duration: 1, delay: 0.5 }}
                  />
                  <motion.line
                    x1="100" y1="100" x2="140" y2="160"
                    stroke="#00D4FF"
                    strokeWidth="1"
                    strokeDasharray="4 4"
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    transition={{ duration: 1, delay: 0.7 }}
                  />
                </svg>
              </div>

              {/* Data cards */}
              <div className="satellite-data-cards">
                <motion.div
                  className="sat-data-card"
                  whileHover={{ scale: 1.05 }}
                >
                  <span className="sat-data-label">GHI Today</span>
                  <span className="sat-data-value">5.8 kWh/m²</span>
                </motion.div>
                <motion.div
                  className="sat-data-card"
                  whileHover={{ scale: 1.05 }}
                >
                  <span className="sat-data-label">Soiling Loss</span>
                  <span className="sat-data-value sat-data-alert">-3.2%</span>
                </motion.div>
              </div>
            </div>
          </ScrollReveal>

          <div className="feature-content">
            <ScrollReveal>
              <span className="feature-badge badge-space">Satellite Intelligence</span>
            </ScrollReveal>

            <ScrollReveal delay={0.1}>
              <h2 className="feature-title">
                40 years of{' '}
                <GradientText gradient="satellite">solar data.</GradientText>
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <p className="feature-description">
                Free satellite data from NASA POWER and Copernicus Sentinel.
                Compare expected vs. actual performance. Detect soiling from space.
                No sensors required - coverage for any location on Earth.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.3}>
              <div className="feature-stats">
                <div className="feature-stat">
                  <span className="feature-stat-value">18</span>
                  <span className="feature-stat-label">Satellite APIs</span>
                </div>
                <div className="feature-stat">
                  <span className="feature-stat-value">40yr</span>
                  <span className="feature-stat-label">Historical Data</span>
                </div>
                <div className="feature-stat">
                  <span className="feature-stat-value">Free</span>
                  <span className="feature-stat-label">Data Access</span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.4}>
              <div className="data-sources">
                <h4>Data Sources</h4>
                <div className="sources-list">
                  {dataSources.map((source, i) => (
                    <motion.div
                      key={i}
                      className="source-item"
                      whileHover={{ x: 5 }}
                    >
                      <div className="source-info">
                        <span className="source-name">{source.name}</span>
                        <span className="source-type">{source.type}</span>
                      </div>
                      <div className="source-meta">
                        <span className="source-years">{source.years}</span>
                        <span className={`source-status status-${source.status}`} />
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  )
}
